import actionTypes from '../types/actionTypes'

const mobileDataReducer = {
	[actionTypes.SET_NAV_OPEN]: (state, action) => {
		state.mobile.isNavOpen = action.payload
	},
}

export default mobileDataReducer
